export const REPORT_GET_MULTIPLE =  "REPORT_GET_MULTIPLE"
export const REPORT_GET_ONE =  "REPORT_GET_ONE"
export const REPORT_REGISTER_SUCCESS =  "REPORT_REGISTER_SUCCESS"
export const REPORT_REGISTER_FAIL =  "REPORT_REGISTER_FAIL"
export const REPORT_LOADING =  "REPORT_LOADING"
export const REPORT_LOADING_ERROR =  "REPORT_LOADING_ERROR"
export const REPORT_ACTIVATE_FAIL =  "REPORT_ACTIVATE_FAIL"
export const REPORT_ACTIVATE_SUCCESS =  "REPORT_ACTIVATE_SUCCESS"
export const REPORT_UPDATE_SUCCESS =  "REPORT_UPDATE_SUCCESS"
export const REPORT_UPDATE_FAIL =  "REPORT_UPDATE_FAIL"
export const REPORT_DELETE_SUCCESS =  "REPORT_DELETE_SUCCESS"
export const REPORT_DELETE_FAIL =  "REPORT_DELETE_FAIL"
export const REPORT_EDIT =  "REPORT_EDIT"